import { AR, EN } from '@shabic/constants';

export type Language = typeof EN | typeof AR;
export const mainLanguage = EN;
export const Languages: Language[] = [EN, AR];
export const langCountry = {
  en: 'US',
  ar: 'SA',
};
